<template>
    <div class="sign-up">
        <h3>Let's create a new account !</h3>
        <md-field><label>EMail:</label><md-input type="text" v-model="email" placeholder="Email"/></md-field>
        <md-field><label>Password:</label><md-input type="password" v-model="password" placeholder="Password"/></md-field>
        <md-button v-on:click="signUp">Sign Up</md-button>
        <p>or go back to <router-link to="/login">login</router-link>.</p>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'signUp',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('hello')
        },
        (err) => {
          alert('Opps. ' + err.message)
        }
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue